import { render, staticRenderFns } from "./GoodsReturn.vue?vue&type=template&id=1f7db1bc"
import script from "./GoodsReturn.vue?vue&type=script&lang=js"
export * from "./GoodsReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports